import { do_anything, do_nothing } from 'apprise-core/action'
import { noTenant } from 'apprise-core/tenant'
import { User } from 'apprise-core/user'


export type LoginMode = 

    'walled'                    // all requests are authenticated. 
    
    | 
    
    'guest-allowed'             // some requests are authenticated.
    
    | 

    'open'                     // no requesta are authenticated.



export const devauthzHeader = 'authorization-dev'


export const authflowapi = () => {
    
    
        const self = {
    
    
            prefix: () => '/oauth2'

            ,

            // the idp-facing callbacks of the flow: FA redirects here after login, logout, and the upstream leg.
            loginCallback: () => `${self.prefix()}/cblogin`

            ,

            logoutCallback: () => `${self.prefix()}/cblogout`

            ,

            extLogoutCallback: () => `${self.prefix()}/extcblogout`

            ,

            logout: () => `${self.prefix()}/logout`

            ,

            logged: () => '/logged'
    
            
        }
    
        return self
    
    }



export const guest: User = {
    username: 'apprise-guest',
    tenant: 'guest',
    tags: [],
    guarded: true,
    lifecycle: {
        state: 'active',
        created: Date.now()
    },
    details: {

        firstname: 'Apprise',
        lastname: 'Guest',
        email: 'apprise-guest@apprisecraft.com',
        preferences: {}
    },
    permissions: [do_nothing]

}

export const admin: User = {
    username: 'apprise-admin',
    tenant: noTenant,
    tags: [],
    guarded: true,
    lifecycle: {
        state: 'active',
        created: Date.now()
    },
    details: {

        firstname: 'Apprise',
        lastname: 'Admin',
        email: 'apprise-admin@apprisecraft.com',
        preferences: {}
    },
    permissions: [do_anything]

}


// models in-cluster, service-to-service requests
export const appservice: User = {
    username: 'app-service',
    tenant: '*',
    tags: [],
    guarded: true,
    lifecycle: {
        state: 'active',
        created: Date.now()
    },
    details: {

        firstname: 'Apprise',
        lastname: 'Service',
        email: 'apprise-service@apprisecraft.com',
        preferences: {}
    },
    permissions: [do_anything]

}

